export { renderLabel_unstable as renderLabel } from '@fluentui/react-label';
